import axios from 'axios';
import { BaseURL } from "./env";

const language = localStorage.getItem('i18nextLng') || 'en' ;
let headers = { "Accept-Language": language } ;

export default axios.create({
  baseURL: BaseURL ,
  headers,
});